var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doRender)?_c('div',{staticClass:"view view_Nachrichten"},[_c('h1',[_vm._v("This is a Nachrichten page")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }